import React, { useState, useEffect } from "react";
import Login from "../Login";
import MicrosoftLogin from "../MicrosoftLogin";
import WhatsappLogin from "../WhatsappLogin";
import Passwordless from "../Landing/Passwordless/Passwordless";

function SignIn() {
  const [loggingProvider, setLoggingProvider] = useState("none");

  useEffect(() => {
    // Apply light theme
    document.getElementById("root")?.setAttribute("data-theme", "light");
    document.getElementById("html")?.setAttribute("data-theme", "light");

    // Set document title
    document.title = "Calendbook - Login Page";

    // Ensure Tidio chat is visible
    window.tidioChatApi?.show();
  }, []);

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-gap-4">
      {/* Google Login */}
      {(loggingProvider === "none" || loggingProvider === "google") && (
        <div className="tw-w-[350px]">
          <Login redirect="/" setLoggingProvider={setLoggingProvider} />
        </div>
      )}

      {/* Microsoft Login */}
      {(loggingProvider === "none" || loggingProvider === "microsoft") && (
        <div className="tw-w-[350px]">
          <MicrosoftLogin
            redirect="/"
            setLoggingProvider={setLoggingProvider}
          />
        </div>
      )}

      {/* Passwordless Login */}
      {(loggingProvider === "none" || loggingProvider === "passwordless") && (
        <div className="tw-w-[350px]">
          <Passwordless setLoggingProvider={setLoggingProvider} />
        </div>
      )}

      {/* WhatsApp Login */}
      {(loggingProvider === "none" || loggingProvider === "whatsapp") && (
        <div className="tw-w-[350px]">
          <WhatsappLogin redirect="/" setLoggingProvider={setLoggingProvider} />
        </div>
      )}
    </div>
  );
}

export default SignIn;
